import { APP_INITIALIZER, NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import {
  CategoryPageMetaResolver,
  ProductPageMetaResolver,
  ProductSearchAdapter,
  provideConfig,
  RoutingService,
  WindowRef
} from '@spartacus/core'
import {
  CmsPageGuard,
  CurrentProductService,
  PageLayoutComponent,
  ProductFacetService,
  ProductListComponentService,
  ProductListItemContextSource
} from '@spartacus/storefront'
import { EbAuthService } from '../auth/services/eb-auth.service'
import { EbCarouselService } from './components/eb-carousel/eb-carousel.service'
import { EB_PRODUCT_SEARCH_PAGE_NORMALIZER } from './converters/converters'
import { EbProductSearchPageNormalizer } from './converters/normalizers/eb-product-search-page.normalizer'
import { ebProductGridLayoutConfig } from './eb-product-layout.config'
import { interceptors } from './interceptor'
import { EbAvailabilityAdapter } from './services/connectors/eb-availability.adapter'
import { EbPricesAdapter } from './services/connectors/eb-prices.adapter'
import { EbProductDetailAdapter } from './services/connectors/eb-product-detail.adapter'
import { EbProductSearchAdapter } from './services/connectors/eb-product-search.adapter'
import { EbProductAdapter } from './services/connectors/eb-product.adapter'
import { EbAvailabilityService } from './services/facades/eb-availability.service'
import { EbCategoryPageMetaResolver } from './services/facades/eb-category-page-meta.resolver'
import { EbCurrentProductService } from './services/facades/eb-current-product.service'
import { EbPricesService } from './services/facades/eb-prices.service'
import { EbProductDetailService } from './services/facades/eb-product-detail.service'
import { EbProductFacetService } from './services/facades/eb-product-facet.service'
import { EbProductListComponentService } from './services/facades/eb-product-list-component.service'
import { EbProductPageMetaResolver } from './services/facades/eb-product-page-meta.resolver'
import { EbProductService } from './services/facades/eb-product.service'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: null,
        canActivate: [CmsPageGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'variant' }
      }
    ])
  ],
  exports: [],
  providers: [
    ...interceptors,

    ProductListItemContextSource,
    EbPricesService,
    EbPricesAdapter,
    EbAvailabilityService,
    EbAvailabilityAdapter,
    EbProductAdapter,
    EbCurrentProductService,
    EbProductService,
    EbCarouselService,
    {
      provide: CurrentProductService,
      useClass: EbCurrentProductService
    },
    {
      provide: ProductPageMetaResolver,
      useClass: EbProductPageMetaResolver
    },
    {
      provide: CategoryPageMetaResolver,
      useClass: EbCategoryPageMetaResolver
    },
    {
      provide: ProductListComponentService,
      useClass: EbProductListComponentService
    },
    {
      provide: ProductFacetService,
      useClass: EbProductFacetService
    },
    {
      provide: APP_INITIALIZER,
      useFactory: EbProductDetailService.checkForEncryptedArticleNumber,
      multi: true,
      deps: [EbAuthService, WindowRef, EbProductService, RoutingService]
    },
    EbProductDetailService,
    EbProductDetailAdapter,
    provideConfig(ebProductGridLayoutConfig),
    {
      provide: EB_PRODUCT_SEARCH_PAGE_NORMALIZER,
      useExisting: EbProductSearchPageNormalizer,
      multi: true
    },
    {
      provide: ProductSearchAdapter,
      useClass: EbProductSearchAdapter
    }
  ]
})
export class EbProductModule {}
